import { type HttpClient } from '../useHttpClient';
import { type Response } from '../hooks/useUsersWidgetsData';

export const getUsersWidgetsData = (httpClient: HttpClient) => async () => {
  const response = await httpClient.api('/admin/users/widgets', {
    method: 'GET',
  });

  return response.json as Response;
};
